module.exports = __webpack_public_path__ + "static/media/listingPage.e8f1538f.png";